import { render, staticRenderFns } from "./EtapaDocumentacaoContato.vue?vue&type=template&id=755141ee"
import script from "./EtapaDocumentacaoContato.vue?vue&type=script&lang=js"
export * from "./EtapaDocumentacaoContato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports